// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AddressValidationResultModel } from "@guestsupply/App/Services/AddressValidationService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type AddressValidationStateModel = {
    addressValidation: AddressValidationResultModel;
    isSubmitted: boolean;
};

const initialState: AddressValidationStateModel = {
    addressValidation: {
        errorCode: 0,
        errorMessage: "",
        candidates: [],
    },
    isSubmitted: false,
};

const reducer = {
    "xAddressValidation/SetAddressValidationData": (
        draft: Draft<AddressValidationStateModel>,
        action: { addressValidation: AddressValidationResultModel },
    ) => {
        draft.addressValidation = action.addressValidation;
    },
    "xAddressValidation/SetIsSubmittedAddressValidationData": (
        draft: Draft<AddressValidationStateModel>,
        action: { isSubmitted: boolean },
    ) => {
        draft.isSubmitted = action.isSubmitted;
    },
    "xAddressValidation/ClearAddressValidationData": (draft: Draft<AddressValidationStateModel>) => {
        draft.addressValidation = {
            errorCode: 0,
            errorMessage: "",
            candidates: [],
        };
        draft.isSubmitted = false;
    },
};

const xAddressValidation = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xAddressValidation = xAddressValidation;

export type xAddressValidation = {
    xAddressValidation: AddressValidationStateModel;
} & ApplicationState;

type AddressValidationReducer = {
    addressValidation: typeof xAddressValidation;
};

export type AddressValidationActions =
    | Parameters<AddressValidationReducer[keyof AddressValidationReducer]>[1]
    | AnyAction;
